const mapSearchPhraseParams = (
    isCreate,
    {
        pinned_search_results_attributes,
        ...params
    },
) => {
    return new Promise((resolve) => {
        resolve({
            search_phrase: {
                phrase: params.phrase,
                status: params.status,
                expires_at: params.expires_at,
                pinned_search_results_attributes: (pinned_search_results_attributes || []).map((item) => ({
                    id: item.id,
                    searchable_type: item.searchable_type,
                    searchable_id: item.searchable_id,
                    position: item.position,
                    _destroy: item._destroy,
                })),
            },
        });
    });
};

export { mapSearchPhraseParams };
